import accordion from "./accordion";
import header from "./header";
import responsive from "./responsive";
